// extracted by mini-css-extract-plugin
export default {"button":"transaction_button__t0yW9 common_button__gAtsh common_button_sm__UQfrM"};